export const getDefaultISDCode = () => ({
  name: "United States",
  dial_code: "+1",
  code: "US",
});
